import React from 'react'
import {motion} from "framer-motion"
import { Link } from 'react-router-dom'
import about_4 from "../../../assets/images/about/rtb-logo.svg"
import Members from '../../../assets/icons/members'
import Technology from '../../../assets/icons/technology'
import { slideUp } from '../../../utlits/slideUp'
const AboutOne = () => {
    return (
        <section className="about-area style-2 pb-75">
            <div className="container">
                <motion.div className="row align-items-center"
                    initial="offscreen"
                    whileInView="onscreen"
                    variants={slideUp()}
                    viewport={{ once: true, amount: 0.4 }}
                >
                    <div className="col-lg-6">
                        <div className="about-image style-2">
                            <div className="image-1">
                                <img src={about_4} alt="right-to-bear" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content style-2">
                            <div className="title">
                                <span className="d-block"></span>
                                <h2>Legal Protection for Responsible Gun Owners.</h2>
                                <p>Protection applies where you live and lawfully carry, with a membership designed to support you before, during, and after a self-defense incident and the flexibility to add additional protection as your needs grow. </p>

<p>This membership provides access to upfront legal defense, real attorney access, and ongoing education so you’re not left navigating the aftermath alone.</p> 

<p>Protection that follows you at home, at work, and in everyday life, with a membership designed to support you before, during, and after a self-defense incident.</p>
<p>Click below to see all the options they offer, and be sure to use discount code J5CONS to save!</p>
                            </div>
                            
                            <a className="default-btn text-decoration-none" href="https://protectwithbear.com/pages/plans?gad_source=1&gad_campaignid=23284210206">
                                <i className="ri-arrow-right-line"></i>
                                Click Here to Learn More
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    )
}

export default AboutOne


